import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { flowRight } from 'lodash/fp';
import { formValues } from 'redux-form';
import { withPropsOnChange } from 'recompose';
import withTargetRecommendations from '../../approval/withTargetRecommendations';
import RecommendationsLists from './RecommendationLists';
import { PrecoChoices } from './PrecoChoices';
import SelectContact from '../../field/SelectContact';
import { useSession } from '../../../sessions';

const renderCifComponent = (choicePreco, name, recommendations, rip, target, isCif, setIsCif, isLodeomCifSelected) => {
    const session = useSession();
    setIsCif('cif' === choicePreco);
    const isSimulation = 'simulation' === choicePreco;

    return (
        <div>
            <PrecoChoices required />
            <SelectContact rip={rip} isCif={isCif} isSimulation={isSimulation} session={session} isLodeomCifSelected={isLodeomCifSelected} />
            {choicePreco &&
                <RecommendationsLists
                    name={name}
                    recommendations={recommendations}
                    isCif={isCif}
                    rip={rip}
                    target={target}
                    choicePreco={choicePreco}
                    needApprovalOnCIFDocument={session.needApprovalOnCIFDocument}
                    needApprovalOnSimulations={session.needApprovalOnSimulations}
                    required
                />}
        </div>
    );
};

const Recommendations = ({ rip, recommendations, name, choicePreco, target, isCif, setIsCif, setTarget, cifRecommendations, cifRecommendationsClientAndPartner }) => {
    setTarget(target);

    const activeCifRecommendations = 'clientAndPartner' === target ? cifRecommendationsClientAndPartner : cifRecommendations;
    const isLodeomCifSelected = isCif && activeCifRecommendations && activeCifRecommendations.some((r) => 'LODEOMCIF' === r.type);

    return (
        <Fragment>
            {renderCifComponent(choicePreco, name, recommendations, rip, target, isCif, setIsCif, isLodeomCifSelected)}
        </Fragment>
    );
};

Recommendations.propTypes = {
    name: PropTypes.string.isRequired,
    setTarget: PropTypes.func,
    recommendations: PropTypes.shape({}),
    rip: PropTypes.shape({
        personalEmail: PropTypes.string.isRequired,
        partnerPersonalEmail: PropTypes.string.isRequired,
        idBoxShoyo: PropTypes.string.isRequired,
        partnerIdBoxShoyo: PropTypes.string.isRequired,
    }),
    choicePreco: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    isCif: PropTypes.bool.isRequired,
    setIsCif: PropTypes.func.isRequired,
    cifRecommendations: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string })),
    cifRecommendationsClientAndPartner: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string })),
};

Recommendations.defaultProps = {
    recommendations: {},
    cifRecommendations: null,
    cifRecommendationsClientAndPartner: null,
};

export default flowRight([
    withTargetRecommendations,
    formValues('target', 'choicePreco', { cifRecommendations: 'recommendationsCIF', cifRecommendationsClientAndPartner: 'recommendationsCIFClientAndPartner' }),
    withPropsOnChange(['rip', 'choicePreco'], ({ rip, choicePreco }) => {
        if ('simulation' === choicePreco && ('cohabitation' !== rip.familySituation)) {
            return {
                target: 'client',
            };
        }

        return null;
    }),
])(Recommendations);
